/** scroll form into view when opening accordion */
// function scrollFormOpen() {
//   const formLayout = jQuery('.form-layout');
//   const formAccordions = formLayout.find('.accordion');
//
//   formAccordions.on('down.zf.accordion', function() {
//     const $this = jQuery(this);
//
//     const elementTop = $this.parent().offset().top;
//     const elementHeight = $this.parent().innerHeight();
//     const windowTop = jQuery(window).scrollTop();
//     const windowHeight = jQuery(window).height();
//
//     const verticalOffset = elementTop;
//
//     const isFullInView = ( windowTop < verticalOffset ) &&
//       ((windowTop + windowHeight) > (elementTop + elementHeight));
//
//     if (isFullInView === true) return;
//
//     const heightDelta = windowHeight - elementHeight;
//
//     if (heightDelta > 0) {
//       jQuery('html, body')
//         .animate( {scrollTop: verticalOffset - heightDelta}, 600, 'swing');
//     } else {
//       jQuery('html, body')
//         .animate( {scrollTop: verticalOffset}, 600, 'swing' );
//     }
//   });
// }

function scrollFormOpen() {
  const $formLayout = jQuery('.form-layout');
  if ($formLayout.length === 0) return;
  const $formAccordions = $formLayout.find('.accordion');
  if ($formAccordions.length === 0) return;

  $formAccordions.each(function() {
    const $accordion = jQuery(this);
    const $parent = $accordion.parent();
    if ($parent.length === 0) return;

    $accordion.off('down.zf.accordion.vz').on('down.zf.accordion.vz', function() {
      const elementTop = $parent.offset().top;
      const elementHeight = $parent.innerHeight();
      const windowTop = jQuery(window).scrollTop();
      const windowHeight = jQuery(window).height();

      const verticalOffset = elementTop;

      const isFullInView = (windowTop < verticalOffset) &&
        ((windowTop + windowHeight) > (elementTop + elementHeight));

      if (isFullInView) return;

      const heightDelta = windowHeight - elementHeight;

      if (heightDelta > 0) {
        jQuery('html, body').animate({
          scrollTop: verticalOffset - heightDelta
        }, 600, 'swing');
      } else {
        jQuery('html, body').animate({
          scrollTop: verticalOffset
        }, 600, 'swing');
      }
    });
  });
}

/**
 * Binds one form accordion: show either the intro text or the form, never both.
 *
 * Watching the accordion item's state instead of `down.zf.accordion` has two
 * reasons: Foundation fires that event only after the pane finished sliding,
 * and the class flips for clicks, keyboard toggles and programmatic
 * `foundation('down')` calls alike. The 250ms match Foundation's slideSpeed,
 * so text and pane move together.
 */
function formAccordionBindIntro($formLayout, $intro) {
  const $item = $formLayout.find('.accordion-item').first();
  const $reveal = $formLayout.closest('.reveal');
  if ($item.length === 0 || $intro.length === 0) return;

  let wasOpen = $item.hasClass('is-active');

  const observer = new MutationObserver(function() {
    const isOpen = $item.hasClass('is-active');
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;

    // Popup only: `form-open` carries the full-bleed layout and the height
    // floor that keeps the modal from collapsing while HubSpot measures its
    // iframe. Outside a modal the set is empty and this does nothing.
    $reveal.toggleClass('form-open', isOpen);

    if (isOpen) {
      $intro.stop(true, true).slideUp(250);
    } else {
      $intro.stop(true, true).slideDown(250);
    }
  });

  observer.observe($item[0], {attributes: true, attributeFilter: ['class']});
}

/**
 * The two places that carry a HubSpot form accordion. They differ only in
 * where the intro text sits: beside the form module in the popup, inside the
 * accordion item in the newsletter module below posts and CPT entries.
 */
function formAccordionHideIntro() {
  if (typeof MutationObserver === 'undefined') return;

  jQuery('.reveal .form-layout').each(function() {
    const $formLayout = jQuery(this);
    formAccordionBindIntro($formLayout, $formLayout.prevAll('.txt-module').first());
  });

  jQuery('.nl-module.form-layout').each(function() {
    const $formLayout = jQuery(this);
    formAccordionBindIntro($formLayout, $formLayout.find('.nl-module__intro').first());
  });
}
